import axios from "axios";
import {
  notRequiredAndText,
  requiredAndText,
  requiredAndTextMd,
  requiredIfNotKF,
  validarAfinazoneId,
  validarBool,
  validarLitrosYPrecios,
  validateNumberNotRequired,
  validatePrice,
  validateUPC
} from "helpers/validators";
const API_BASE_URL = `${process.env.REACT_APP_LARAVEL_API_HOST}/api`;
const TOKEN = process.env.REACT_APP_LARAVEL_API_TOKEN;

const LABELS_KAT = {
  0: "afinazone_id",
  1: "titulo",
 
  2: "tipo_producto",
  3: "marca_aceite",
  4: "caracteristica",
  5: "unidad",
  6: "variantes_aceite",

  39: "introduccion",
  40: "contenido",
  41: "adicional",
  42: "compatibilidad",
  43: "final",

  44: "portada",
  45: "complemento_1",
  46: "fluido_aceite",
  47: "sticker",

  48: "folleto",
  49: "deshabilitar_aceite",
  50: "stock",
  51: "producto_recomendado",
  52: "variante_recomendada",
  53: "revision",
};


const FIELD_VALIDATORS = {
  afinazone_id: (value) => validarAfinazoneId(value),
  titulo: (value) => requiredAndText(value, 'titulo'),
  tipo_producto: (value) => requiredAndText(value, 'tipo de producto'),

  marca_aceite: (value,) => requiredAndText(value, 'marca aceite'),
  caracteristica: (value,) => requiredAndText(value, 'caracteristica'),
  unidad: (value, condition) => requiredAndText(value, condition, 'unidad'),
  variantes_aceite: (value,) => requiredAndText(value, 'variantes_aceite'),

  introduccion: (value) => requiredAndTextMd(value, 'introducción'),
  contenido: (value) => requiredAndTextMd(value, 'contenido'),
  adicional: (value) => requiredAndTextMd(value, 'adicional'),
  compatibilidad: (value) => requiredAndTextMd(value, 'compatibilidad'),
  final: (value) => requiredAndTextMd(value, 'final'),

  portada: (value) => requiredAndText(value, 'portada'),
  complemento_1: (value) => requiredAndText(value, 'complemento 1'),
  fluido_aceite: (value, condition) => requiredAndText(value, 'fluido aceite'),
  sticker: (value) => requiredAndText(value, 'sticker'),

  folleto: (value) => validarBool(value),
  deshabilitar_aceite: (value) => validarBool(value),
  stock: (value) => validarBool(value),
  producto_recomendado: (value) => validarBool(value),
  variante_recomendada: (value) => validateNumberNotRequired(value),
  revision: (value) => validarBool(value),
};



export async function uploadNewAceiteItems(data) {
  const errors = {};
  const validItems = [];

  data.forEach(item => {
    const afinazone_id = item[0];

    // Ignorar items sin ID válido
    if (afinazone_id === undefined || afinazone_id === null || afinazone_id === "") {
      return; // Saltar a la siguiente iteración
    }

    const result = createBody(item);
    if (!result.success) {
      if (!errors[afinazone_id]) errors[afinazone_id] = [];
      errors[afinazone_id].push(...result.errors);
    } else {
      validItems.push(result.body);
    }
  });

  if (Object.keys(errors).length > 0) {
    return {
      success: false,
      error: errors,
      message: "Errores de validación encontrados"
    };
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}/afinazone/aceite/bulk`,
      { items: validItems },
      {
        timeout: 60000,
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );

    console.log("✅ Items subidos con éxito:", response.data);
    return { success: true, data: response.data };
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      console.error("⏳ Timeout: La solicitud tardó demasiado y fue cancelada");
      return { success: false, error: "Timeout: La solicitud tardó demasiado" };
    }

    console.error(
      "❌ Error en la subida:",
      error.response?.data || error.message
    );
    return { success: false, error: error.response?.data || error.message };
  }
}

function createBody(data) {

  if (data[0] === undefined || data[0] === "") return null;

  const body = {};
  const errors = [];

  // Validar cada campo
  for (const [index, value] of data.entries()) {
    const label = LABELS_KAT[index];
    if (!label) continue; // Si no existe el label, lo saltamos

    const validator = FIELD_VALIDATORS[label];
    if (!validator) {
      body[label] = value; // Si no hay validador, se asigna el valor crudo
      continue;
    }

    const result = validator(value, data[3]);
    if (!result.valid) {
      errors.push({
        label,
        value,
        message: result.error
      });
    } else {
      body[label] = result.value;
    }
  }

  const result = validarLitrosYPrecios(data, 7, 37);
  if (!result.valid) {
    errors.push({
      label: 'litros',
      message: result.error
    });
  } else {
    body['litros'] = result.value;
  }

  return {
    success: errors.length === 0,
    body: errors.length === 0 ? body : null,
    errors: errors.length > 0 ? errors : null
  };
}
